<template>
  <div class="container">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <fai icon="user"/>&nbsp;Editar Prospecto
        </div>
      </div>
      <div class="card-body pb-5">
        <!--begin: Details -->
        <div class="row mt-4">
          <div class="col-sm-6">
            <h4 class="font-info">Datos Generales</h4>
          </div>
        </div>
        <sys-form :inputs="prospect_details"/>
        <!--end: Details -->
        <hr class="mt-4"/>
        <!--begin: Investment Info -->
        <div class="row mt-4">
            <div class="col-sm col-md col-lg">
                <h4 class="m--font-info">Datos de inversión</h4>
            </div>
        </div>
        <sys-form :inputs="prospect_investment"/>
        <!--end: Investment Info -->
      </div>
      <div class="card-footer text-right">
        <button class="btn btn-secondary" @click="$router.push({ name: 'prospect', params: { id: prospect.id } })">
          <fai icon="reply"/> Cancelar
        </button>
        <button class="btn btn-success" :class="{ 'disabled': form.isSaving }" @click="saveForm">
          <fai :icon="['far','edit']"/> Guardar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import promotersService from '@/services/promoters'
import prospectsService from '@/services/prospects'
import SysForm from '@/components/shared/Form'
import formMixin from '@/mixins/form'

export default {
  name: 'ProspectUpdate',

  components: { SysForm },

  mixins: [ formMixin ],

  data () {
    return {
      prospect: {},
      prospect_details: {
        promoter_id: {
          name: 'Promotor',
          value: '',
          type: 'select',
          size: 12,
          options: []
        },
        name: {
          name: 'Nombre',
          hint: 'Nombre',
          value: '',
          type: 'text',
          validate: 'required'
        },
        lastname_father: {
          name: 'Apellido Paterno',
          hint: 'Apellido Paterno',
          value: '',
          type: 'text',
          validate: 'required'
        },
        lastname_mother: {
          name: 'Apellido Materno',
          hint: 'Apellido Materno',
          value: '',
          type: 'text',
          validate: 'required'
        },
        email: {
          name: 'Correo',
          hint: 'Correo',
          value: '',
          type: 'email'
        },
        telephone: {
          name: 'Teléfono',
          hint: 'Teléfono',
          value: '',
          type: 'text'
        },
        mobile: {
          name: 'Celular',
          hint: 'Celular',
          value: '',
          type: 'text'
        },
        dob: {
          name: 'Fecha de nacimiento',
          hint: '2000/12/31',
          value: '',
          type: 'date'
        },
        nationality: {
          name: 'Nacionalidad',
          hint: 'Nacionalidad',
          value: '',
          type: 'text'
        },
        rfc: {
          name: 'RFC',
          hint: 'RFC',
          value: '',
          type: 'text'
        },
        type: {
          name: 'Tipo',
          hint: 'Seleccione una opcion',
          value: null,
          type: 'select',
          options: [
            { value: 'Fisica', text: 'Física' },
            { value: 'Moral', text: 'Moral' }
          ]
        },
        status_id: {
          name: 'Estatus',
          hint: 'Estatus del prospecto',
          value: null,
          type: 'select',
          options: []
        },
        corporate_name: {
          name: 'Nombre Corporativo',
          hint: 'Nombre corporativo',
          value: null,
          type: 'text'
        }
      },
      prospect_investment: {
        investment: {
          name: 'Monto de Mínimo',
          hint: 'Monto de Inversión',
          value: '',
          type: 'number'
        },
        investment_end: {
          name: 'Monto de Máximo',
          hint: 'Monto de Inversión',
          value: '',
          type: 'number'
        },
        interest: {
          name: 'Tasa de Interes',
          hint: 'Tasa de Interes',
          value: '',
          type: 'number',
          min: 0,
          max: 100
        },
        investment_date: {
          name: 'Fecha de Inversión desde',
          value: '',
          type: 'date'
        },
        investment_date_end: {
          name: 'Fecha de Inversión hasta',
          value: '',
          type: 'date'
        }
      }
    }
  },

  created: function () {
    this.loaded = false
    promotersService.list().then(res => {
      this.prospect_details.promoter_id.options = res.data.map(promoter => {
        return { value: promoter.id, text: promoter.fullname }
      })
    })
    const id = this.$route.params.id
    prospectsService.getById(id).then(res => {
      this.prospect = res.data
      this.prospect_details.type.value = { value: this.prospect.type, text: this.prospect.type }
      Object.keys(this.prospect_details).forEach(key => {
        if (this.prospect_details[key].type != 'select') {
          this.prospect_details[key].value = this.prospect[key]
        }
      })
      Object.keys(this.prospect_investment).forEach(key => {
        this.prospect_investment[key].value = this.prospect[key]
      })

      prospectsService.getStatusList().then(list => {
        this.prospect_details.status_id.options = list.map(status => {
          return { value: status.id, text: status.description }
        })

        this.prospect_details.status_id.value = { value: this.prospect.status_id, text: this.prospect.status_description }
      })

      this.loaded = true
    })
  },

  methods: {
    saveForm: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let prospectInfo = { ...this.prospect_details, ...this.prospect_investment }

          let body = this.processForm(prospectInfo)
          let service = prospectsService.updateById(this.prospect.id, body)

          this.sendForm(service).then(res => {
            this.$router.push({ name: 'prospect', params: { id: this.prospect.id } })
          }).catch(err => {
            console.log(JSON.stringify(err.statusText))
          })
        }
      })
    }
  },

  watch: {
    'prospect_details.type.value': function (type, oldType) {
      if (oldType === '') return
      if (type.value === 'Fisica') {
        delete this.prospect_details['corporate_name']
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/prospects/ProspectUpdate.vue